export const PASSWORD_RULE =
  "Password must be at least 8 characters and include one uppercase letter and one special character.";

export function passwordIssue(pw) {
  pw = pw || "";
  if (pw.length < 8) return PASSWORD_RULE;
  if (!/[A-Z]/.test(pw)) return PASSWORD_RULE;
  if (!/[^A-Za-z0-9\s]/.test(pw)) return PASSWORD_RULE;
  return null;
}
